// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ButtonCollection__root___s8WR0","item":"ButtonCollection__item___D68RQ","centered":"ButtonCollection__centered___o8Ilz","fullWidth":"ButtonCollection__fullWidth___ytXtb"};